function Informationpage(){
    return(
        
        <div className="info_1">
            <div className="information_page">
                
                
                <h3>&#127807;What is anxiety?</h3>
                <p>
                Anxiety is a feeling of fear, dread, and uneasiness. It might cause you to sweat, feel restless and tense, and have a rapid heartbeat. It can be a normal reaction to stress. For example, you might feel anxious when faced with a difficult problem at work, before taking a test, or before making an important decision. It can help you to cope. The anxiety may give you a boost of energy or help you focus. But for people with anxiety disorders, the fear is not temporary and can be overwhelming.
                </p>

                <h3>&#127807;What causes anxiety?</h3>
        
                <p>
                The cause of anxiety is unknown. Factors such as genetics, brain biology and chemistry, stress, and your environment may play a role.
                </p>
                
                <h3>&#127807;What are the types of anxiety disorders?</h3>
                
                There are several types of anxiety disorders, including:
                <ul>
                    <li>Generalized anxiety disorder (GAD).People with GAD worry about ordinary issues such as health, money, work, and family. But their worries are excessive, and they have them almost every day for at least 6 months.</li>
                    <li>Panic disorder. People with panic disorder have panic attacks. These are sudden, repeated periods of intense fear when there is no danger. The attacks come on quickly and can last several minutes or more.</li>
                    <li>Phobias. People with phobias have an intense fear of something that poses little or no actual danger. Their fear may be about spiders, flying, going to crowded places, or being in social situations (known as social anxiety).</li>
                </ul>
            </div>

            <br/>

            <div className="videos">
                <iframe title="myFrame" width="420" height="315"
                src="https://www.youtube.com/embed/tNYrtO0QHVs">
                </iframe>
                
                <iframe title="myFrame2" width="420" height="315"
                src="https://www.youtube.com/embed/H2NC3W7lmk8">
                </iframe>

            </div>
            
            
        </div>
    )
}


export default Informationpage